import { useTranslation } from 'react-i18next'
import { MouseEvent, useState } from 'react'
import { useDispatch } from 'react-redux'
import { MediaFile } from '../../../entity'
import { PhotoInfoModal } from './photo-info-modal'
import { MediaFileModal } from './media-file-modal'
import { MessageModal } from '../../../component/modal'
import { WarrantyStatus } from '../../../enum/warranty-status.enum'
import { deletePhoto } from '../../../action/photos'
import { EditMediaFileModal } from './edit-media-file-modal'
import { PHOTO_EDITOR_ACTIONS } from '../../../action/photos/photos.constants'
import { uploadPhotosData } from '../../../action/photos/upload-photos-data.action'
import { PhotoStatus } from '../../../enum/photo-status.enum'
import './warranty-card.scss'
import {useNavigate} from "react-router-dom";

interface WarrantyCardProps {
    warrantyStatus: WarrantyStatus
    mediaFile: MediaFile
    warrantyId: number
}

export const WarrantyCard = (props: WarrantyCardProps) => {
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const navigate = useNavigate()

    const [infoModalVisible, setInfoModalVisible] = useState(false)
    const [photoModalVisible, setPhotoModalVisible] = useState(false)
    const [deletePhotoModalVisible, setDeletePhotoModalVisible] = useState(false)
    const [selectedPhoto, setSelectedPhoto] = useState(null as MediaFile | null)
    const [editPhotoMessageModalVisible, setEditPhotoMessageModalVisible] = useState(false)
    const [editPhotoModalVisible, setEditPhotoModalVisible] = useState(false)

    const onPhotoClick = async (event: MouseEvent) => {
        event.preventDefault()

        setPhotoModalVisible(!photoModalVisible)
    }

    const onInfoButtonClick = async (event: MouseEvent) => {
        event.preventDefault()

        setInfoModalVisible(!infoModalVisible)
    }

    const onCopyLinkButtonClick = async (event: MouseEvent) => {
        event.preventDefault()

        // navigator.clipboard.writeText(window.location.origin + `/photo/${props.photo.hash}`)
        navigator.clipboard.writeText(props.mediaFile.coveredUrl)

        // Get the snackbar DIV
        var x = document.getElementById('snackbar')

        // Add the "show" class to DIV
        x!!.className = 'show'

        // After 3 seconds, remove the show class from DIV
        setTimeout(function () {
            x!!.className = x!!.className.replace('show', '')
        }, 3000)
    }

    return (
        <div className="warranty-card">
            <div className="photo-container" onClick={onPhotoClick}>
                {/* <img alt="Photo" className="photo" src={`${props.photo.coveredUrl}?${new Date().getTime()}`} /> */}
                <img alt="Photo" className="photo" src={props.mediaFile.type === 0 ? props.mediaFile.coveredUrl : props.mediaFile.coveredThumbnail} />

                <img alt="Status icon" className="status" src={props.mediaFile.metadata?.status === PhotoStatus.UPLOADED ? '/image/ic_check.svg' : '/image/ic_circle.svg'} />

                {props.mediaFile.metadata?.created!! - props.mediaFile.metadata?.mobileCreated!! > 600 ? <label className="offline">{t('warranty_card_offline')}</label> : null}

                {props.mediaFile.type === 1 && <img alt="" className="video-indicator" height={112} src="/video.svg" width={112} />}
            </div>

            <div className="warranty-card__buttons">
                <button className="button" onClick={onInfoButtonClick}>
                    {t('warranty_card_info_button')}
                </button>

                <button className="button" disabled={props.warrantyStatus === WarrantyStatus.ACCEPTED ? false : true} onClick={onCopyLinkButtonClick}>
                    {t('warranty_card_copy_link_button')}
                </button>
            </div>

            {infoModalVisible ? (
                <PhotoInfoModal
                    mediaFile={props.mediaFile}
                    onCloseClick={() => {
                        setInfoModalVisible(!infoModalVisible)
                    }}
                />
            ) : null}

            {photoModalVisible ? (
                <MediaFileModal
                    mediaFile={props.mediaFile}
                    warrantyStatus={props.warrantyStatus}
                    onDeleteCallback={(photo: MediaFile) => {
                        setPhotoModalVisible(!photoModalVisible)

                        setSelectedPhoto(photo)
                        setDeletePhotoModalVisible(!deletePhotoModalVisible)
                    }}
                    onEditCallback={(photo: MediaFile) => {
                        setPhotoModalVisible(!photoModalVisible)

                        setSelectedPhoto(photo)

                        setEditPhotoMessageModalVisible(!editPhotoMessageModalVisible)
                    }}
                    onCloseClick={() => {
                        setSelectedPhoto(null)

                        setPhotoModalVisible(!photoModalVisible)
                    }}
                />
            ) : null}

            {deletePhotoModalVisible ? (
                <MessageModal
                    title={t('delete_photo_modal_title')}
                    message={t('delete_photo_modal_message')}
                    okTitle={t('button_delete')}
                    onCloseClick={() => {
                        setSelectedPhoto(null)

                        setDeletePhotoModalVisible(!deletePhotoModalVisible)
                    }}
                    onCancelClick={() => {
                        setSelectedPhoto(null)

                        setDeletePhotoModalVisible(!deletePhotoModalVisible)
                    }}
                    onOkClick={async () => {
                        await deletePhoto(selectedPhoto!!.id, props.warrantyId)

                        setSelectedPhoto(null)

                        setDeletePhotoModalVisible(!deletePhotoModalVisible)
                    }}
                />
            ) : null}

            {editPhotoMessageModalVisible ? (
                <MessageModal
                    title={t(props.mediaFile.type === 0 ? 'edit_photo_modal_title' : 'edit_video_modal_title')}
                    message={t(props.mediaFile.type === 0 ? 'edit_photo_modal_message' : 'edit_video_modal_message')}
                    okTitle={t('button_edit')}
                    onCloseClick={() => {
                        setSelectedPhoto(null)

                        setEditPhotoMessageModalVisible(!editPhotoMessageModalVisible)
                    }}
                    onCancelClick={() => {
                        setSelectedPhoto(null)

                        setEditPhotoMessageModalVisible(!editPhotoMessageModalVisible)
                    }}
                    onOkClick={async () => {
                        if (props.mediaFile.type === 0) {
                            setSelectedPhoto(null)

                            setEditPhotoMessageModalVisible(!editPhotoMessageModalVisible)

                            setEditPhotoModalVisible(!editPhotoModalVisible)
                        } else {
                            navigate(`/warranty/${props.warrantyId}/video-editor/${ props.mediaFile.id }`)
                        }
                    }}
                />
            ) : null}

            {editPhotoModalVisible ? (
                <EditMediaFileModal
                    warrantyId={props.warrantyId}
                    mediaFile={props.mediaFile}
                    onCloseClick={() => {
                        dispatch({ type: PHOTO_EDITOR_ACTIONS.CLEAR })

                        setSelectedPhoto(null)

                        setEditPhotoModalVisible(!editPhotoModalVisible)
                    }}
                    onCancelCallback={() => {
                        dispatch({ type: PHOTO_EDITOR_ACTIONS.CLEAR })

                        setSelectedPhoto(null)

                        setEditPhotoModalVisible(!editPhotoModalVisible)
                    }}
                    onAcceptCallback={() => {
                        uploadPhotosData(props.warrantyId)

                        setSelectedPhoto(null)

                        setEditPhotoModalVisible(!editPhotoModalVisible)
                    }}
                />
            ) : null}

            <div id="snackbar">{t('warranty_card_copy_link_message')}</div>
        </div>
    )
}
